module.exports = __webpack_public_path__ + "src/assets/textures/leaves/cotton_leaf_opacity_map.jpg";